// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-ping-indicator {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  cursor: help;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
}

.network-ping-indicator__icon {
  display: block;
}

.network-ping-indicator__label {
  font-size: 10px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.network-ping-indicator--good {
  color: #34d399;
}

.network-ping-indicator--slow {
  color: #fbbf24;
}

.network-ping-indicator--offline {
  color: #f87171;
}

.network-ping-indicator--unknown {
  color: #9ca3af;
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/components/NetworkPingIndicator.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf","sourcesContent":[".network-ping-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  cursor: help;\n  line-height: 1;\n  user-select: none;\n}\n\n.network-ping-indicator__icon {\n  display: block;\n}\n\n.network-ping-indicator__label {\n  font-size: 10px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.network-ping-indicator--good {\n  color: #34d399;\n}\n\n.network-ping-indicator--slow {\n  color: #fbbf24;\n}\n\n.network-ping-indicator--offline {\n  color: #f87171;\n}\n\n.network-ping-indicator--unknown {\n  color: #9ca3af;\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
